/**
 * 礼物/勋章 单个组件
 * */

import React from 'react';
import Util from '../../../script/util';
import './AchieveItem.scss';

const AchieveItem = ({
  children,
  className,
  status = true,
  cover,
  name,
  num,
  onClick = null,
}) => {
  return (
    <li
      className={Util.classNames(
        'achieve-item-wrap',
        { 'is-light': status },
        className
      )}
      onClick={onClick}
    >
      {children}
      <div className="achieve-cover">
        <img src={Util.transImgUrl(cover, '104x104')} alt={name} />
      </div>
      <div className="achieve-foot">
        <h5 className="achieve-name">{name}</h5>
        {!!num && <p className="achieve-num">x{num}</p>}
      </div>
    </li>
  );
};

export default AchieveItem;
